import type {
  TopicHandoffEndpoint,
  TopicHandoffEventData,
} from "@redotech/effect-api-shared/models/shopper-ai/conversation/timeline-event/timeline-event";
import type { SupportTicketTimelineEventResponse } from "@redotech/effect-api-shared/models/shopper-ai/conversation/timeline-event/timeline-event-response";
import SwitchHorizontalIcon from "@redotech/redo-icons/switch-horizontal-01_filled.svg";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { formatSentenceCase } from "@redotech/util/string";
import { memo } from "react";
import { EventTimestamp } from "./event-timestamp";
import * as styles from "./timeline-event.module.css";

function endpointLabel(endpoint: TopicHandoffEndpoint): string {
  if (endpoint.label) {
    return endpoint.label;
  }

  if (endpoint._tag === "topic") {
    return "topic";
  }

  return formatSentenceCase(endpoint.actorType.replace(/_/g, " "));
}

export const TopicHandoffEvent = memo(function TopicHandoffEvent({
  event,
  data,
}: {
  event: SupportTicketTimelineEventResponse;
  data: TopicHandoffEventData;
}) {
  const details =
    data.reason ??
    (data.channel
      ? `Future ${formatSentenceCase(data.channel)} messages route here`
      : null);

  return (
    <Flex align="flex-start" className={styles.card} gap="sm">
      <Flex
        align="center"
        className={`${styles.icon} ${styles.iconOrange}`}
        justify="center"
      >
        <SwitchHorizontalIcon />
      </Flex>
      <Flex className={styles.content} dir="column" gap="xxs">
        <Text fontSize="xs" fontWeight="medium" textColor="primary">
          {endpointLabel(data.from)} handed off to {endpointLabel(data.to)}
        </Text>
        {details && (
          <Text className={styles.details} fontSize="xxs" textColor="secondary">
            {details}
          </Text>
        )}
        <EventTimestamp event={event} />
      </Flex>
    </Flex>
  );
});
